<template>
  <div v-hotkey="keymap">
    <div class="accordion-header" v-if="showPaneMargin">
      <b-button class="btn-sm accordion-toggle-btn" block @click="togglePaneOpen($event)" v-bind:class="{ active: paneOpen }">
        <div>ניקוד ידני</div>
        <div v-if="!paneOpen"><i-caret-up></i-caret-up></div>
        <div v-else><i-caret-down></i-caret-down></div>
      </b-button>
    </div>
    <div v-show="paneOpen" class="mb-2" v-bind:class="{'scroll-manual-pane': twoPanesOpen && localShowNikudButtons}">
      <div v-if="lettersOfCurrentWord.length == 0 && nakdanStyle.Mobile" class="text-center text-muted pt-4">
        כדי לערוך ניקוד,
        <br/>
        יש ללחוץ על מילה מתוך הטקסט
      </div>      
      <p class="clear-nikud" v-if="useNikudKeyboardPopup" @click="showNikudKeyboardPopup = true">
        <i-keyboard></i-keyboard> מקלדת ניקוד
      </p>
      <div v-else style="height: 6px" />
      <div class="manual-nikud-box-container"> <!-- v-if="localCurrentWordIndex > -1" -->
        <span class="letters-wrap">
          <div class="word-letters-screen">
            <div v-show="currentLetterNotSep" class="ml-auto"><span v-for="(letter, le) in lettersOfCurrentWord" :key="le">
              <span v-show="showLetter(letter, le)"><span class="letter-on-screen" v-bind:class="(!localLetterAddingMode && (le == localCurrentLetterIndex)) ? 'highlighted-letter' : ''" @click="changeCurrentLetterIndex(le)" v-html="displayLetter(letter)"></span> <span v-show="localLetterAddingMode && (le == localCurrentLetterIndex)" class="editing-cursor">|</span> </span></span>
            </div>
            <div v-if="implementUserAccounts">
              <div
                v-show="currentLetterNotSep && $store.state.userDictionary.entryPresent[localCurrentWord.chosenWordString]"
                @click="removeFromUserDictionary(localCurrentWord.chosenWordString)"
                class="dictionary-button"><i-star :solid="true"></i-star>
              </div>
              <div
                v-show="currentLetterNotSep && !($store.state.userDictionary.entryPresent[localCurrentWord.chosenWordString]) && localCurrentWord && localCurrentWord.altered"
                @click.stop="tryToAddToUserDictionary" class="dictionary-button">
                <i-star></i-star>
              </div>
            </div>
            <div v-if="nakdanStyle.Desktop" v-b-tooltip title="הסר ניקוד" v-show="currentLetterNotSep" @click="clearNikudClicked" class="dictionary-button close-hover mr-0">
              <i-times ></i-times>
            </div>
            <div v-else  v-show="currentLetterNotSep" @click="clearNikudClicked" class="dictionary-button close-hover mr-0">
              <i-times ></i-times>
            </div>            
          </div>
        </span>  
        <p v-show="localShowNikudButtons" class="nikud-option-buttons-area" :class="{'raised-frame': currentLetterNikudOptions.length}">
          <span v-for="(option, o) in currentLetterNikudOptions"
                :key="o">
            <span class="nikud-option-button letter-in-nikud-option-button"
                  @click="nikudOptionClicked(option.text); moveToNextLetter('auto')"
            >{{ option.text.replace(/וֹ/g, '\ufb4b') }}</span>
            <!--allow a line break-->
<!--            <span>&#8203;</span>-->
          </span>
          <br/>
          <span v-show="currentLetterShin || currentLetterSin" 
              class="pr-1 nikud-option-button nikud-option-button-bg" @click="reverseDotting">שנה ל <span
              class="letter-in-nikud-option-button">{{ oppositeDotting }}</span></span>
          <span v-show="canReverseDagesh" class="pr-1 nikud-option-button nikud-option-button-bg" 
            @click="reverseDagesh">{{ dageshReversalString }}</span>
          <span v-show="currentLetterAimCandidate" class="pr-1 nikud-option-button nikud-option-button-bg"
            @click="changeCurrentLetter('AIM')">{{ aimReversalString }}</span>
        </p>
      </div>
      <a href="#"
        class="clickable-link"
        v-if="showPaneMargin"
        @click="showApplyToAllPopup = true">החל על כל הטקסט</a>
      <div v-if="nakdanStyle.Mobile" class="save-changes-footer">
        <b-button
          id="apply-button"
          size="lg" block
          @click="useNewNikud(); modesObj.multiPaneOpen = false"
          variant="primary">שמור שינויים
        </b-button>
      </div>      
    </div>
    <b-modal id="apply-to-all-popup"
             v-model="showApplyToAllPopup"
             ok-title="החל"
             cancel-title="ביטול"
             centered
             @ok="applyToEntireText"
             size="sm"
    >
      <template slot="modal-header"><div> החל על כל הטקסט</div></template>
      <b-form-radio id="doBelow" value="below" v-model="applyToAllMode"> החל ממילה זו והלאה</b-form-radio>
      <b-form-radio id="doUnedited" value="unedited" v-model="applyToAllMode"> החל רק על מילים שלא נערכו</b-form-radio>
      <b-form-radio id="doAll" value="all" v-model="applyToAllMode"> החל על כל הטקסט</b-form-radio>
    </b-modal>

    <b-modal id="nikud-keyboard-popup"
             v-if="useNikudKeyboardPopup"
             v-model="showNikudKeyboardPopup"
             centered
             @ok="applyNikudKeyboardPopupOptions"
             ok-title="בצע"
             cancel-title="ביטול"
    >
      <template slot="modal-header"><div><i-keyboard></i-keyboard> מקלדת ניקוד</div></template>
      <div v-if="useMultipleNikudKeyboards">
        <p>שיטת ניקוד: הגדר את שיטת הניקוד, לניקוד באמצעות מקלדת המחשב</p>
        <!--<div class="right-column">שיטת ניקוד</div>-->
        <b-form-radio-group stacked
                            v-model="nikudKeyboardOption"
        >
          <b-form-radio id="doNew" value="new"> שיטה חדשה (אותיות)
            <b-button v-b-modal.nikud-whole-keyboard-popup-new size="sm" variant="link" class="text-primary px-1">תצוגה מקדימה</b-button>
          </b-form-radio>
          <b-form-radio id="doOld" value="old"> שיטה ישנה (מספרים)
            <b-button v-b-modal.nikud-whole-keyboard-popup-old size="sm" variant="link" class="text-primary px-1">תצוגה מקדימה</b-button>
          </b-form-radio>
          <b-form-radio id="doBlind" value="blind"> שיטה עיוורת
            <b-button v-b-modal.nikud-whole-keyboard-popup-blind size="sm" variant="link" class="text-primary px-1">תצוגה מקדימה</b-button>
          </b-form-radio>
        </b-form-radio-group>
        <div class="nikud-keyboard-popup-hr"><hr></div>
      </div>
      <div v-if="canShowOrHideNikudButtons">
        <p>הצגת מקלדת</p>
        <b-form-radio-group stacked
                            v-model="showButtonsOption"
        >
          <b-form-radio id="doNotShowButtons" :value="false"> אל תציג מקלדת</b-form-radio>
          <b-form-radio id="doShowButtons" :value="true"> הצג מקלדת
            <span class="keyboard-key-text"> Shift + k</span>
          </b-form-radio>
        </b-form-radio-group>
      </div>
    </b-modal>
    <!-- (not needed - the popups are already there under קיצורי מקלדת)
   <keyboard-keys-popup></keyboard-keys-popup>
   -->
    <div v-if="implementUserAccounts"
         class="manual-nikud-account-needed-popup click-only-here" 
         v-show="showAccountNeededPopup">
      כדי להוסיף מילה למאגר, יש להתחבר לחשבון האישי.
    </div>
  </div>
</template>

<script>

// import KeyboardKeysPopup from "./keyboard-keys-popup"; (not needed - popups already there under קיצורי מקלדת)
import {processNikudSingleLineIntoStructure} from '../js/wordBreakup'
import nikudMixins from '@/mixins/nikudMixins'
import manualNikudPaneKeyMap from '@/mixins/manualNikudPaneKeyMap'
import {RunStates} from '@/store/runStates'
import _ from 'lodash'
import $ from 'jquery'
import serviceMixins from '@/mixins/serviceMixins'
import navigationMixins from '@/mixins/navigationMixins'
import resultsIntegrationMixins from '@/mixins/resultsIntegrationMixins'
import wordMutatingMixins from '@/mixins/wordMutatingMixins'
import {LETTER, stringWithoutNikud, getCurrentLetterSin,
        getCurrentLetterDagesh, getLetterWithReversedDageshFromLetterArray} from '@/js/commonHebrew'
import {getChosenWordString, getStandardLetterArray} from '@/js/letterOperations'
import {AppConfig} from '../appConfig'
import {SimpleVsProConfig} from '@/simpleVsProConfig.js'
import {NakdanStyle, MobileVsDesktopConfig} from '@/mobileVsDesktopConfig.js'

const DAGESH = 'ּ'
const SINDOT = 'ׂ'
const SHINDOT = 'ׁ'
const QAMATZ = 'ָ'
const QAMATZ_QATAN = 'ׇ'
const PATAH = 'ַ'
const TSERE = 'ֵ'
const SEGOL = 'ֶ'
const HIRIQ = 'ִ'
const SHEVA = 'ְ'
const HOLAM = 'ֹ'
const QUBUTZ = 'ֻ'
const HATAFPATAH = 'ֲ'
const HATAFQAMATZ = 'ֳ'
const HATAFSEGOL = 'ֱ'
const METEG = 'ֽ'

export default {
  name: 'ManualNikudPane',
  mixins: [
    nikudMixins, /* for the direct use of: localCurrentWordIndex, localCurrentLetterIndex, 
                      localNikudKeyboard (in KeyMap), localLetterAddingMode (here AND KeyMap),
                      localCurrentWord (here AND KeyMap), currentLetterNotSep (here AND KeyMap),
                      modalOpen() (in keymap), removeFromUserDictionary(), callForNewNikud(), 
                      showChangedNikudMessage(), showChangedKeyboardMessage(), and display() ...
                    ...and for the use, as a changeAllAlikeWordsToNewNikud() dependency, of: getAllAlikeWordsToChange()... */
    resultsIntegrationMixins, // for finishEditingWordGroup()
    wordMutatingMixins, /* for the direct use of: rewriteWordOrWordsInWorkingArrayMethod() and 
                          changeAllAlikeWordsToNewNikud() ...
                        ...& b/c (now) whoever uses resultsIntegrationMixins needs wordMutatingMixins too */
    manualNikudPaneKeyMap, // for keymap
    serviceMixins, // for gtag()
    navigationMixins // for moveToNextWord() and moveToPreviousWord()
  ],
  props: ['subPanesStatus', 'modesObj', 'editNikudProps'],
  data () {
    return {
      useOnAllText: false,
      lettersOfCurrentWord: [],
      keyIndices: {},
      applyToAllMode: 'below',
      showApplyToAllPopup: false,
      workingWord: null, // for 'redoing nikud' of multiple words
      waitingToRedoNikud: false, // ditto
      workingIndices: [], // ditto
      // data items below here are used only by the 'Pro' Nakdan
      addToUserDictionary: false,
      showAccountNeededPopup: false,
      showButtonsOption: false,
      showNikudKeyboardPopup: false,
      nikudKeyboardOption: 'blind' // not a 'real' default - that's loaded from the store when 'mounted'
    }
  },
  computed: {
    nakdanStyle () {
      return NakdanStyle // Mobile: window.innerWidth < 992, Desktop: window.innerWidth >= 992
    },
    showPaneMargin () {
      return MobileVsDesktopConfig.SHOW_MARGINS_WITH_PANES
    },
    implementUserAccounts () {
      return SimpleVsProConfig.IMPLEMENT_USER_ACCOUNTS
    },
    useLetterAddingMode () {
      return SimpleVsProConfig.USE_LETTER_ADDING_MODE
    },
    useMultipleNikudKeyboards () {
      return SimpleVsProConfig.USE_MULTIPLE_NIKUD_KEYBOARDS
    },
    canShowOrHideNikudButtons () {
      return SimpleVsProConfig.NIKUD_BUTTONS.CAN_SHOW_OR_HIDE
    },
    useNikudKeyboardPopup () {
      return this.useMultipleNikudKeyboards || this.canShowOrHideNikudButtons
    },
    paneOpen () {
      return this.subPanesStatus.manualOpen
    },
    localOptionsPaneOpen () {
      return this.subPanesStatus.optionsOpen
    },
    twoPanesOpen () {
      return Object.values(this.subPanesStatus).filter(v => v).length > 1
    },
    currentLetterDagesh: function () {
      return getCurrentLetterDagesh(this.lettersOfCurrentWord, this.localCurrentLetterIndex)
    },
    currentLetterSin: function () {
      return getCurrentLetterSin(this.lettersOfCurrentWord, this.localCurrentLetterIndex)
    },
    currentLetterShin: function () {
      var shin = false
      if (this.lettersOfCurrentWord && (this.localCurrentLetterIndex !== -1) && this.lettersOfCurrentWord[this.localCurrentLetterIndex]) {
        shin = (this.lettersOfCurrentWord[this.localCurrentLetterIndex].indexOf(SHINDOT) !== -1) || ((this.lettersOfCurrentWord[this.localCurrentLetterIndex].indexOf('ש') !== -1) && (!(this.currentLetterSin)))
      }
      return shin
    },
    currentLetterAimCandidate () {
      return !(this.$store.state.preSubmissionOptions.ketivMaleh) 
        && this.lettersOfCurrentWord[this.localCurrentLetterIndex] 
        && 'אהוי'.split('').includes(this.lettersOfCurrentWord[this.localCurrentLetterIndex][0])
    },
    currentLetterNikudOptions: function () {
      var nikudOptions = []
      if (this.lettersOfCurrentWord && (this.localCurrentLetterIndex !== -1) 
          && this.lettersOfCurrentWord[this.localCurrentLetterIndex]
          && 'קראטוןםפשדגכעיחלךףזסבהנמצתץ'.includes(this.lettersOfCurrentWord[this.localCurrentLetterIndex][0])) {
        var letterWithoutNikud = this.lettersOfCurrentWord[this.localCurrentLetterIndex].replace(/[^א-ת]/g, '')
        var workingLetter = letterWithoutNikud
        // if ((letterWithoutNikud !== 'ו') && (this.currentLetterDagesh)) {
        if (this.currentLetterDagesh && (letterWithoutNikud !== 'ו')) {
          workingLetter += DAGESH
        }
        nikudOptions.push({name: '', text: workingLetter})
        // if ((letterWithoutNikud !== 'ו') || (!(this.currentLetterDagesh))) {
        if (letterWithoutNikud === 'ש') {
          nikudOptions.push({
            name: (this.currentLetterSin ? 'SINDOT' : 'SHINDOT'), 
            text: workingLetter + (this.currentLetterSin ? SINDOT : SHINDOT)
          })
          workingLetter += (this.currentLetterSin ? SINDOT : SHINDOT)
        }
        if ('םףץ'.indexOf(letterWithoutNikud) === -1) {
          nikudOptions.push({name: 'QAMATZ', text: workingLetter + QAMATZ})
        }
        if ('םףץןך'.indexOf(letterWithoutNikud) === -1) {
          if (this.$store.state.preSubmissionOptions.useQamatzQatan
              || AppConfig.ALWAYS_SHOW_QAMATZ_QATAN_BUTTON) {
            nikudOptions.push({name: 'QAMATZ_QATAN', text: workingLetter + QAMATZ_QATAN})
          }
          nikudOptions.push({name: 'PATAH', text: workingLetter + PATAH})
          nikudOptions.push({name: 'TSERE', text: workingLetter + TSERE})
          nikudOptions.push({name: 'SEGOL', text: workingLetter + SEGOL})
          nikudOptions.push({name: 'HIRIQ', text: workingLetter + HIRIQ})
        }
        if ('םףץן'.indexOf(letterWithoutNikud) === -1) {
          nikudOptions.push({name: 'SHEVA', text: workingLetter + SHEVA})
        }
        if ('םףץןך'.indexOf(letterWithoutNikud) === -1) {
          nikudOptions.push({name: 'HOLAM', text: workingLetter + HOLAM})
          nikudOptions.push({name: 'QUBUTZ', text: workingLetter + QUBUTZ})
          nikudOptions.push({name: 'HATAFPATAH', text: workingLetter + HATAFPATAH})
        }
        if ('םףץן'.indexOf(letterWithoutNikud) === -1) {
          nikudOptions.push({name: 'HATAFQAMATZ', text: workingLetter + HATAFQAMATZ})
        }
        if ('םףץןך'.indexOf(letterWithoutNikud) === -1) {
          nikudOptions.push({name: 'HATAFSEGOL', text: workingLetter + HATAFSEGOL})
        }
        if (letterWithoutNikud === 'ו' && !(this.currentLetterDagesh)) {
          nikudOptions.push({name: 'SHURUQ', text: workingLetter + DAGESH})
        }
      }
      return nikudOptions
    },
    oppositeDotting: function () {
      return 'ש' + (this.currentLetterSin ? SHINDOT : SINDOT)
    },
    canReverseDagesh: function () {
      return this.currentLetterNikudOptions.length
              && !(['ם', 'ץ', 'ן'].includes(this.lettersOfCurrentWord[this.localCurrentLetterIndex].replace(/[^א-ת]/g, ''))
                    && !(this.currentLetterDagesh))
    },
    dageshReversalString: function () {
      return this.currentLetterDagesh ? 'הסר דגש' : 'הוסף דגש'
    },
    aimReversalString: function () {
      return this.lettersOfCurrentWord[this.localCurrentLetterIndex] 
        && this.lettersOfCurrentWord[this.localCurrentLetterIndex].includes('ֽ') ? 'הגדר עיצור'
                                                                                : 'הגדר אם קריאה'
    },
    localnakdanApiState: function () {
      return this.$store.state.nakdanApiState
    },
    nakdanRunning () {
      return this.$store.state.nakdanApiState === RunStates.RUNNING
    },
    localShowNikudButtons () {
      return this.$store.state.postSubmissionOptions.showNikudButtons
    },
    oldNikudKeyboardActive () {
      return !(SimpleVsProConfig.NO_KEYBOARD_NIKUD_AT_ALL) && this.localNikudKeyboard === 'old' && !(this.localLetterAddingMode) && this.currentLetterNotSep
    },
    newNikudKeyboardActive () {
      return !(SimpleVsProConfig.NO_KEYBOARD_NIKUD_AT_ALL) && this.localNikudKeyboard === 'new' && !(this.localLetterAddingMode) && this.currentLetterNotSep
    },
    blindNikudKeyboardActive () {
      return !(SimpleVsProConfig.NO_KEYBOARD_NIKUD_AT_ALL) && this.localNikudKeyboard === 'blind' && !(this.localLetterAddingMode) && this.currentLetterNotSep
    },
    localCurrentWordSeps () {
      return this.localCurrentWord ? (this.localCurrentWord.sepBefore + this.localCurrentWord.sepAfter) : ''
    },
    localWordMutationCount () {
      return this.modesObj.wordMutationCount
    }
  },
  watch: {
    localCurrentWordIndex: function (newLocalCurrentWordIndex) {
      if (newLocalCurrentWordIndex !== -1) this.initLettersOfCurrentWord('to-chosen-word-with-nikud', /* 'leave-current-letter' */ )
    },
    localWordMutationCount: function () {
      if (this.localCurrentWordIndex !== -1) this.initLettersOfCurrentWord('to-chosen-word-with-nikud', /* 'leave-current-letter' */)
    },
    localCurrentWordSeps: function () {
      if (this.localCurrentWordIndex !== -1) this.initLettersOfCurrentWord('to-chosen-word-with-nikud', /* 'leave-current-letter' */)
    },
    currentLetterNikudOptions: function (newCurrentLetterNikudOptions) {
      this.keyIndices = _.fromPairs(newCurrentLetterNikudOptions.map((key, index) => [key.name, index]))
    },
    localnakdanApiState: function (newLocalnakdanApiState) {
      if (this.editNikudProps && !(this.editNikudProps.showEditNikud) && newLocalnakdanApiState === RunStates.COMPLETE) {
        /* if (this.nakdanCallType === 'redo-nikud') { 
          this.finishRedoingNikud() 
        } else { */ this.finishEditingWordGroup(); this.moveAfterEditingWordGroupIfNeeded() /* } */
      }
    },
    paneOpen: function (newPaneOpen) {
      if (newPaneOpen && this.localShowNikudButtons) this.subPanesStatus.optionsOpen = false
    },
    localOptionsPaneOpen: function (newLocalOptionsPaneOpen) {
      if (newLocalOptionsPaneOpen && this.paneOpen && this.localShowNikudButtons) this.setShowNikudButtons(false)
    },
    // watches below here are used only by the 'Pro' Nakdan
    localShowNikudButtons: function (newShowButtons) {
      this.showButtonsOption = newShowButtons
      if (this.paneOpen && newShowButtons) this.subPanesStatus.optionsOpen = false
    },
    localNikudKeyboard: function (newNikudKeyboard) {
      this.nikudKeyboardOption = newNikudKeyboard
    },
    showNikudKeyboardPopup: function (newShowNikudKeyboardPopup) {
      if (newShowNikudKeyboardPopup) {
        this.gtag("event", "show popup", {
          'event_category': 'manual nikud pane',
          'event_label': 'show nikud-keyboards popup'
        })
      }
    }
  },
  methods: {
    displayLetter (letter) {
      return this.display(letter.replace(/וֹ/g, '\ufb4b'), this.$store.state.postSubmissionOptions.showAims, true)
    },
    showLetter (letter, le) {
      return (this.displayLetter(letter) !== '') && (le >= this.localCurrentWord.sepBefore.length)
        && (le < (this.localCurrentWord.sepBefore.length + this.localCurrentWord.standardLetterArray.length))
    },
    togglePaneOpen () {
      this.subPanesStatus.manualOpen = !(this.subPanesStatus.manualOpen)
    },
    changeCurrentLetterIndex (le) {
      this.$store.commit('SET_CURRENT_LETTER_INDEX', le)
    },
    initLettersOfCurrentWord (mode /* , currentLetterMode = 'reset-unless-clearing-nikud' */ ) {
      this.lettersOfCurrentWord = this.localCurrentWord.sepBefore.split('').concat(
          (mode === 'clear-nikud')
              ? getStandardLetterArray(stringWithoutNikud(getChosenWordString(this.localCurrentWord)))
              : this.localCurrentWord.standardLetterArray).concat(
                                      this.localCurrentWord.sepAfter.split(''))
      /*
      if ((mode === 'to-chosen-word-with-nikud') && (currentLetterMode !== 'leave-current-letter')) {
        this.changeCurrentLetterIndex(-1)
        setTimeout(() => {
          if (this.localCurrentLetterIndex === -1) this.changeCurrentLetterIndex(this.localCurrentWord.sepBefore.length)
        }, 3)
      } */
    },
    clearNikudClicked () {
      this.initLettersOfCurrentWord('clear-nikud')
      this.useNewNikud()
    },
    nikudOptionClicked (optionText) {
      var lettersOfCurrentWord = [] // re-create the array so the change will be reactive
      this.lettersOfCurrentWord.forEach(letter => {
        lettersOfCurrentWord.push(letter)
      })
      lettersOfCurrentWord[this.localCurrentLetterIndex] = optionText
      this.lettersOfCurrentWord = lettersOfCurrentWord
      if (NakdanStyle.Desktop) this.useNewNikud()
    },
    reverseDotting () {
      const original = this.lettersOfCurrentWord[this.localCurrentLetterIndex]
      const replacement = this.currentLetterSin ? original.replace(SINDOT, SHINDOT)
                  : (original.includes(SHINDOT) ? original.replace(SHINDOT, SINDOT)
                    : (this.currentLetterDagesh ? original.replace(DAGESH, DAGESH + SINDOT)
                                                : original.replace('ש', 'ש' + SINDOT)))
      this.nikudOptionClicked(replacement)
      this.useNewNikud()
    },
    reverseDagesh () {
      var reversedLetter = getLetterWithReversedDageshFromLetterArray(this.lettersOfCurrentWord, this.localCurrentLetterIndex)
      this.nikudOptionClicked(reversedLetter)
      this.useNewNikud()
    },
    changeCurrentLetter (nikudName) {
      if (!('קראטוןםפשדגכעיחלךףזסבהנמצתץ'.includes(this.lettersOfCurrentWord[this.localCurrentLetterIndex][0]))) {
        return // separator
      } else if (nikudName === 'DAGESH') {
        this.reverseDagesh()
      } else if ((nikudName === 'SHINDOT') || (nikudName === 'SINDOT')) {
        if (nikudName in this.keyIndices) {
          this.nikudOptionClicked(this.currentLetterNikudOptions[this.keyIndices[nikudName]].text)
        } else this.reverseDotting()
      } else {
        if (nikudName in this.keyIndices) {
          this.nikudOptionClicked(this.currentLetterNikudOptions[this.keyIndices[nikudName]].text)
          this.moveToNextLetter('auto')
        } else { 
          if (nikudName === 'AIM') {
            if (this.lettersOfCurrentWord[this.localCurrentLetterIndex].includes('ֽ')) {
                this.changeCurrentLetter('CLEAR')
            } else {
              if ('אהוי'.includes(this.lettersOfCurrentWord[this.localCurrentLetterIndex][0])) {
                this.nikudOptionClicked(this.lettersOfCurrentWord[this.localCurrentLetterIndex][0] + METEG)
                this.$store.commit('SET_SHOW_AIMS', true) // makes condition in next line superfluous
                /* if (this.$store.state.postSubmissionOptions.showAims) */ this.moveToNextLetter('auto')
              }
            }
          } else { // nikudName == "CLEAR"
            this.nikudOptionClicked(this.currentLetterNikudOptions[0].text)
            if (this.currentLetterDagesh) this.reverseDagesh()
          }
        }
      }
    },
    moveToNextLetter (mode = 'manual') {
      if (this.localCurrentLetterIndex < (this.lettersOfCurrentWord.length - 1)) {
        this.changeCurrentLetterIndex(this.localCurrentLetterIndex + 1)
        if (this.display(this.lettersOfCurrentWord[this.localCurrentLetterIndex]) === '' || this.lettersOfCurrentWord.length < this.localCurrentLetterIndex && this.lettersOfCurrentWord[this.localCurrentLetterIndex - 1].includes(HIRIQ) && (this.lettersOfCurrentWord[this.localCurrentLetterIndex] === 'י')) {
          this.moveToNextLetter(mode)
        }
      } else {
        const triggeredByNikudChange = mode === 'auto'
        const usingLetterCursor = SimpleVsProConfig.MAIN_RESULTS_WINDOW.USE_LETTER_CURSOR
        const letterNavKeys = !(SimpleVsProConfig.NAVIGATION_KEYS_FOR_WORDS_ONLY)
        const nikudChangeCannotMoveToNextWord = !usingLetterCursor || !letterNavKeys // "next word" here is SEP!
        const preventMoveToNextWord = (triggeredByNikudChange && nikudChangeCannotMoveToNextWord)
                                        || NakdanStyle.Mobile
        if (!preventMoveToNextWord) this.moveToNextWord('manual')
      }
    },
    moveToPreviousLetter () {
      if (this.localCurrentLetterIndex > 0) {
        this.changeCurrentLetterIndex(this.localCurrentLetterIndex - 1)
        if (this.display(this.lettersOfCurrentWord[this.localCurrentLetterIndex]) === '') {
          this.moveToPreviousLetter()
        }
      } else this.moveToPreviousWord('manual')
    },
    processAddingOrDeletingCharacter (charAddedOrDeleted) {
      // new policy - only call the API if there is a "change in WORD(S)"
      if (Object.values(LETTER).includes(charAddedOrDeleted[0])) { // [0] b/c there may be more, such as a meteg
        this.callForNewNikud(this.workingWord)
      } else {
        // get the word/sep breaks from our own code
        let stripped = stringWithoutNikud(this.workingIndices.map((i) => {
          const w = this.$store.state.allWorkingNikud.wordsArray[i]
          return w.sepBefore + w.chosenWordString + w.sepAfter
        }).join('').trim())
        const workingWordOldStructure = processNikudSingleLineIntoStructure(stripped)
        stripped = stringWithoutNikud(this.workingWord.trim())
        const workingWordNewStructure = processNikudSingleLineIntoStructure(stripped)
        // console.log('workingWordOldStructure:')
        // console.log(workingWordOldStructure)
        // console.log('workingWordNewStructure:')
        // console.log(workingWordNewStructure)
        const wordsInOldStructure = workingWordOldStructure.filter(seg => !(seg.sep)).length
        const wordsInNewStructure = workingWordNewStructure.filter(seg => !(seg.sep)).length
        // this.waitingToRedoNikud = true
        if (wordsInNewStructure !== wordsInOldStructure) {
          this.callForNewNikud(this.workingWord)
        } else {
          this.$store.commit('SET_NAKDAN_RESULTS', workingWordNewStructure)
          setTimeout(() => {
            this.finishEditingWordGroup('use-existing-options')
            this.moveAfterEditingWordGroupIfNeeded()
          }, 1)
        }
      }
      // end of "new policy" code
    },
    deleteCurrentLetter () {
      if (this.localCurrentLetterIndex < this.localCurrentWord.sepBefore.length) {
        const newSepBefore = this.localCurrentWord.sepBefore.slice(0, this.localCurrentLetterIndex)
              + this.localCurrentWord.sepBefore.slice(this.localCurrentLetterIndex + 1)
        if (newSepBefore === '' && this.localCurrentWordIndex > 0) {
          const deletedChar = this.localCurrentWord.sepBefore[this.localCurrentLetterIndex]
          const prevWord = this.$store.state.allWorkingNikud.wordsArray[this.localCurrentWordIndex - 1]
          const prevWordText = prevWord.sepBefore + prevWord.chosenWordString + prevWord.sepAfter
          this.workingWord = prevWordText + newSepBefore + this.localCurrentWord.chosenWordString + this.localCurrentWord.sepAfter
          this.workingIndices = [this.localCurrentWordIndex - 1, this.localCurrentWordIndex]
          this.processAddingOrDeletingCharacter(deletedChar)
          this.moveToPreviousWord('manual')
        } else {
          this.rewriteWordOrWordsInWorkingArrayMethod({
            contextData: { wordIndex: this.localCurrentWordIndex, letterIndex: this.localCurrentLetterIndex }, // for undo
            newWordContainer: {
              index: this.localCurrentWordIndex, changes: {
                altered: true, 
                choiceType: 'manual',
                manualNikud: this.localCurrentWord.chosenWordString,
                sepBefore: newSepBefore
              }
            }
          })
          if (this.localCurrentLetterIndex > 0) this.changeCurrentLetterIndex(this.localCurrentLetterIndex - 1)
        }
      } else if (this.localCurrentLetterIndex > (this.localCurrentWord.sepBefore.length + this.localCurrentWord.standardLetterArray.length - 1)) {
        const newSepAfter = this.localCurrentWord.sepAfter.slice(0, this.localCurrentLetterIndex - (this.localCurrentWord.sepBefore.length + this.localCurrentWord.standardLetterArray.length))
                + this.localCurrentWord.sepAfter.slice(this.localCurrentLetterIndex - (this.localCurrentWord.sepBefore.length + this.localCurrentWord.standardLetterArray.length) + 1)
        if (newSepAfter === '' && this.localCurrentWordIndex < (this.$store.state.allWorkingNikud.wordsArray.length - 1)) {
          const deletedChar = this.localCurrentWord.sepAfter[this.localCurrentLetterIndex - (this.localCurrentWord.sepBefore.length + this.localCurrentWord.standardLetterArray.length)]
          const nextWord = this.$store.state.allWorkingNikud.wordsArray[this.localCurrentWordIndex + 1]
          const nextWordText = nextWord.sepBefore + nextWord.chosenWordString + nextWord.sepAfter
          this.workingWord = this.localCurrentWord.sepBefore + this.localCurrentWord.chosenWordString + newSepAfter + nextWordText
          this.workingIndices = [this.localCurrentWordIndex, this.localCurrentWordIndex + 1]
          this.processAddingOrDeletingCharacter(deletedChar)
        } else {
          this.rewriteWordOrWordsInWorkingArrayMethod({
            contextData: { wordIndex: this.localCurrentWordIndex, letterIndex: this.localCurrentLetterIndex }, // for undo
            newWordContainer: {
              index: this.localCurrentWordIndex, changes: {
                altered: true, 
                choiceType: 'manual',
                manualNikud: this.localCurrentWord.chosenWordString,
                sepAfter: newSepAfter
              }
            }
          })
          if (this.localCurrentLetterIndex > 0) this.changeCurrentLetterIndex(this.localCurrentLetterIndex - 1)
        }
      } else {
        const deletedLetter = this.lettersOfCurrentWord[this.localCurrentLetterIndex]
        var newWord = this.lettersOfCurrentWord.slice(this.localCurrentWord.sepBefore.length, this.localCurrentLetterIndex).join('')
          + this.lettersOfCurrentWord.slice(this.localCurrentLetterIndex + 1, this.lettersOfCurrentWord.length - this.localCurrentWord.sepAfter.length).join('')
        this.rewriteWordOrWordsInWorkingArrayMethod({
          contextData: { wordIndex: this.localCurrentWordIndex, letterIndex: this.localCurrentLetterIndex }, // for undo
          newWordContainer: {
            index: this.localCurrentWordIndex, changes: { 
              altered: true, 
              manualNikud: newWord,
              choiceType: 'manual' 
            }
          }
        })
        this.workingWord = this.localCurrentWord.sepBefore + newWord + this.localCurrentWord.sepAfter
        this.workingIndices = [this.localCurrentWordIndex]
        this.processAddingOrDeletingCharacter(deletedLetter)
        if (this.localCurrentLetterIndex > 0) this.changeCurrentLetterIndex(this.localCurrentLetterIndex - 1)
      }
      // this.initLettersOfCurrentWord()
      this.modesObj.letterAddingMode = false
    },
    backspaceCurrentLetter () {
      const currentLetterString = this.lettersOfCurrentWord[this.localCurrentLetterIndex]
      if (currentLetterString.replace(METEG, '') === stringWithoutNikud(currentLetterString)) {
        this.deleteCurrentLetter()
      } else this.changeCurrentLetter('CLEAR')
      this.modesObj.letterAddingMode = false
    },
    addCharacter (charToAdd) {
      if (this.localCurrentWordIndex === -1) return
      if (this.$store.state.postSubmissionOptions.showAims && 'אהוי'.includes(charToAdd)) charToAdd += METEG
      this.workingWord = this.lettersOfCurrentWord.slice(0, this.localCurrentLetterIndex + 1).join('') + charToAdd
        + this.lettersOfCurrentWord.slice(this.localCurrentLetterIndex + 1).join('')
      this.workingIndices = [this.localCurrentWordIndex]
      this.processAddingOrDeletingCharacter(charToAdd)
      this.moveToNextLetter('manual')
      setTimeout(() => {
        this.modesObj.letterAddingMode = false
      }, 10)
    },
    useNewNikud () {
      var joined = this.lettersOfCurrentWord.join('')
      if (joined !== this.localCurrentWord.sepBefore + this.localCurrentWord.chosenWordString + this.localCurrentWord.sepAfter) {
        this.rewriteWordOrWordsInWorkingArrayMethod({
          contextData: { wordIndex: this.localCurrentWordIndex, letterIndex: this.localCurrentLetterIndex }, // for undo
          newWordContainer: {
            index: this.localCurrentWordIndex, changes: {
              altered: true, 
              choiceType: 'manual',
              manualNikud: joined.slice(this.localCurrentWord.sepBefore.length, joined.length - this.localCurrentWord.sepAfter.length),
              sepBefore: joined.slice(0, this.localCurrentWord.sepBefore.length),
              sepAfter: joined.slice(joined.length - this.localCurrentWord.sepAfter.length)
            }
          }
        })
      }
      if (this.addToUserDictionary) { // note: only possible in the "Pro" Nakdan
        setTimeout(() => { // wait for localCurrentWord to update
          if (!(this.$store.state.userDictionary.entryPresent[this.localCurrentWord.chosenWordString])) {
            this.$store.commit('UPDATE_USER_DICTIONARY', {
              contextData: { wordIndex: this.localCurrentWordIndex, letterIndex: this.localCurrentLetterIndex }, // for undo
              wordsToAdd: [this.localCurrentWord.chosenWordString]
            })
            this.showAddedToUserDictionaryMessage()
          }
          this.addToUserDictionary = false
        }, 1)
      }
    },
    applyToEntireText () {
      // (needs to have already been done! <== ) this.useNewNikud() // in case this fn happens to get called first (or alone) - doing it twice doesn't hurt
      var changed = this.changeAllAlikeWordsToNewNikud()
      this.showChangedNikudMessage(changed)
      // document.getElementById('apply-button').focus()
      document.activeElement.blur()
    },
    // methods below here are used only by the 'Pro' Nakdan
    applyNikudKeyboardPopupOptions () {
      this.showNikudKeyboardPopup = false
      this.setShowNikudButtons(this.showButtonsOption)
      this.$store.commit('SET_NIKUD_KEYBOARD', this.nikudKeyboardOption)
      this.showChangedKeyboardMessage()
    },
    setShowNikudButtons (b) {
      const alwaysSame = !(this.canShowOrHideNikudButtons)
      if (!alwaysSame || b === SimpleVsProConfig.NIKUD_BUTTONS.SHOW_BY_DEFAULT) {
        this.$store.commit('SET_SHOW_NIKUD_BUTTONS', b)
      } else if (!(this.paneOpen)) this.subPanesStatus.manualOpen = true
    },
    tryToAddToUserDictionary () {
      if (this.$store.state.isLoggedIn) {
        this.addToUserDictionary = true
        this.useNewNikud()
      } else this.showAccountNeededPopup = true
    }
  },
  mounted: function () {
    $(document).on('click', '.click-only-here', function (e) {
      e.stopPropagation()
    })
    $(document).on('click', () => {
      if (this.implementUserAccounts) this.showAccountNeededPopup = false
      this.modesObj.letterAddingMode = false
    })
    $(document).on('keydown', () => {
      if (this.showAccountNeededPopup) this.showAccountNeededPopup = false
    })
    if (this.localCurrentWordIndex > -1) {
      this.initLettersOfCurrentWord('to-chosen-word-with-nikud')
    }
    this.showButtonsOption = this.localShowNikudButtons
    this.nikudKeyboardOption = this.localNikudKeyboard
    if (this.paneOpen && this.localShowNikudButtons) this.subPanesStatus.optionsOpen = false
  },
  /* beforeDestroy () {
    this.changeCurrentLetterIndex(-1)
  } */
}
</script>

<style scoped lang="scss">
.show-buttons {
  padding-top: 13px;
  padding-bottom: 10px;
  padding-right: 7px;
  border-style: solid;
  border-width: 3px;
  border-color: #f6f6f6;
  position: absolute;
  z-index: 10;
  width: 91%;
  right: 2%;
  background-color: white;  
}
.clear-nikud {
  margin: 6px 0 1px 14px;
  font-size: 12px;
  text-align: left;
  cursor: pointer;
  display: inline-block;
  float: left;
  border-radius: 2px;
  padding: 0 6px;
}
.clear-nikud:hover, .clear-nikud:focus {
  background: #E3E3E3;
}
.manual-nikud-box-container {
  clear: both;
  margin: 5px 10px 10px;
  @media screen and (max-width: 767px) {
    margin-top: 6px;
    br {
      display: none;
    }
  }
}
@media screen and (max-width: 767px) {
  .letters-wrap{
    overflow-x:scroll;
    width: calc(100% - 2px);
    display: block;
  }
}
.word-letters-screen {
  background-color: white;
  border-radius: 2px;
  border: solid 1px #000000;
  display: flex;
  align-items: center;
  width: 100%;
  height: 28px;
  padding: 2px 6px;
  margin-bottom: 0;
  line-height: 25px;
  overflow: hidden;
  @media screen and (max-width: 767px) {
    border: solid 1px #e7e7e7;
    background-color: #f6f6f6;
    height: 47px;
    overflow-x:auto;
    width: max-content;
    min-width: 100%;
    align-items: self-start;
  }
}
.letter-on-screen {
  font-family: mft_narkisclassic;
  font-size: 20px;
  cursor: pointer;
  width: 19px;
  display: inline-block;
  height: 28px;
  text-align: center;
  vertical-align: middle;
  @media screen and (max-width: 767px) {
    font-size: 30px;
    width: 40px;
    height: 42px;
    padding-top: 8px;
  }
  
}
.highlighted-letter {
  background-color: #d6ecff;
  @media screen and (max-width: 767px) {
    border-radius: 13px;
    background-color: #d1eaff;
  }
}
.editing-cursor {
  color: #d6ecff;
  background-color: #d6ecff;
}
.nikud-option-buttons-area {
  line-height: 36px;
  /*margin-top: 6px;*/
  /*margin-bottom: 2px;*/
  padding: 3px;
  /*margin-left: 2px;*/
  /*margin-right: 2px;*/
  margin: 6px 2px 2px;
  @media screen and (max-width: 767px) {
    padding: 10px 4px;
    margin-top: 10px; 
    overflow-y: auto;
    max-height: 33vh;
  }
  @media screen and (max-width: 360px) {
    max-height: 27vh;
  }  
  @media screen and (max-width: 320px) {
    max-height: 22vh;
  }  
}
.nikud-option-button-bg {
  min-width: 85px;
}
.nikud-option-button {
  border-radius: 3px;
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.17);
  border: solid 1px #e7e7e7;
  background-color: #f6f6f6;
  padding: 0 6px;
  margin: 4px;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  @media screen and (max-width: 767px) {
    box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.35);
    margin: 2.2%;
  }
}
.letter-in-nikud-option-button {
  font-family: mft_narkisclassic;
  font-size: 22px;
  width: 38px;
  height: 38px;
  @media screen and (max-width: 767px) {
    width: 40px;
    height: 40px;
    font-size: 25px;
  }
}
.use-on-all-text, .add-to-user-dictionary {
  margin: 5px;
}
.pane-bottom {
  position: absolute;
  bottom: 10px;
  width: 95%
}
.nikud-keyboard-popup p {
  cursor: pointer;
  margin: 0;
}
.nikud-keyboard-popup-hr {
  padding: 0 8px;
}

.clear-nikud-x {
  cursor: pointer;
  color: #949494;
}
.normal-line-height {
  line-height: 1.5;
}
.nikud-keyboard-popup-link {
  font-size: 13px;
  padding-left: 4px;
  padding-right: 4px;
  color: #007EE5;
  margin-right: 2px;
}
.nikud-keyboard-popup-link:hover, .nikud-keyboard-popup-link:focus {
  background: #E3E3E3;
  text-decoration: none;
  color: #007EE5;
}
.keyboard-key-text {
  color: #8D8D8D;
  font-size: 13px;
  font-family: Roboto;
}
@media screen and (max-width: 767px) {
  .dictionary-button.close-hover{
    color:#000000!important;
    font-size: 16px;
    height: auto;
    margin-top: 10px;
  }
}
.close-hover:hover{
  background: #e3e3e3;
  cursor: pointer;
}
.save-changes-footer {
  position: absolute;
  height: 70px;
  width: 100%;
  padding: 15px;
  text-align: center;
  right: 0;
  bottom: 0;
}
.accordion-toggle-btn:focus{
 box-shadow: none;
  outline: none;
}
.scroll-manual-pane {
  max-height: calc(100vh - 365px);
  overflow: auto;
}
</style>
